document.addEventListener("DOMContentLoaded", function () {
    function appendUSD() {
        // Select elements with data-instant-dynamic-content-source="PRICE" only
        var priceElements = document.querySelectorAll('[data-instant-dynamic-content-source="PRICE"]');

        // Define a list of currency codes to check
        var currencyCodes = ['AUD', 'CAD', 'EUR', 'USD', 'GBP'];

        // Function to process each element
        priceElements.forEach(function (el) {
            if (el && el.innerText) {
                // Trim text and check if it already includes any currency code
                var text = el.innerText.trim();
                var containsCurrency = currencyCodes.some(function (code) {
                    return text.includes(code);
                });

                // Append 'USD' only if no currency code is present
                if (!containsCurrency) {
                    el.innerText = text + ' USD';
                }
            }
        });
    }

    // Run the function initially
    //appendUSD();

    // Observe mutations to handle dynamic content changes
    var observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.type === 'childList' || mutation.type === 'subtree') {
                //appendUSD();
            }
        });
    });

    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
});
